import { render, staticRenderFns } from "./acts-editor-costs.vue?vue&type=template&id=06fa1b96"
import script from "./acts-editor-costs.vue?vue&type=script&lang=js"
export * from "./acts-editor-costs.vue?vue&type=script&lang=js"
import style0 from "./acts-editor-costs.vue?vue&type=style&index=0&id=06fa1b96&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports